import React from 'react'
import { ThemeProvider, Typography, CssBaseline} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../theme.js'
import { TopBar } from '../components/TopBar/TopBar'
import {Footer} from '../components/Footer/Footer'
import {ControlledAccordions} from '../components/Accordion/Accordion'
import faq from '../images/faq (copy).jpg'
import pagenotfound from '../images/404image.jpg'
import tiling from '../images/blue-tile.png'
export const PageNotFound = () => {
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container spacing={0} style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed"}}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12}>
            <img src={pagenotfound} width = "100%"/>
        </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
